import { useMemo } from "react"

import type { EmailSettings } from "@productlane/zero/schema"

import { sortedInboxAddresses } from "./inbox-addresses"
import { useZeroWorkspace } from "./zero"

export function useInboxAddresses(): EmailSettings[] {
	const workspace = useZeroWorkspace()
	const settings = workspace?.emailSettings

	return useMemo(() => sortedInboxAddresses(settings ?? []), [settings])
}
